import 'css-chunksrc/client/pages/projectPage/kanbanPage/forms/styles.scss';export default {
  "quickAllocationMenu": "_quickAllocationMenu_1vlq2_1",
  "tagMenu": "_tagMenu_1vlq2_5"
};